import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine',
)({
    staticData: {
        metadata: {
            title: 'Decision Engine',
        },
        ui: {
            title: 'Decision Engine Configuration',
            subtitle: 'Configure AI-powered claim decision rules',
            menuDescription: 'Configure AI-powered claim decision rules',
            useTitleForChildren: true,
        },
        presentation: 'fullPage',
        modules: ['claim'],
        permissions: ['settings:update'],
        breadcrumb: {
            title: 'Decision Engine',
        },
        featureFlag: 'enable-ai-decision-engine',
    },

    component: DecisionEngineConfiguration,
});

function DecisionEngineConfiguration() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        label: 'Guide',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide',
                    },
                    {
                        label: 'Overview',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview',
                    },
                    {
                        label: 'Product info',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info',
                    },
                    {
                        label: 'Loss Causes',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes',
                    },
                    {
                        label: 'Policy trigger mapping',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping',
                    },
                    {
                        label: 'Exclusions',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions',
                    },
                    {
                        label: 'Conditions',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions',
                    },
                    {
                        label: 'Red Flags',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags',
                    },
                    {
                        label: 'Limits and excesses',
                        to: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses',
                    },
                ]}
            />
        </PageController>
    );
}
